import Banner from "@/components/landing/homeThree/Banner";
import CallToAction from "@/components/landing/homeThree/CallToAction";
import Faqs from "@/components/landing/homeThree/Faqs";
import Features from "@/components/landing/homeThree/Features";
import HowItsWork from "@/components/landing/homeThree/HowItsWork";
import Testimonials from "@/components/landing/homeThree/Testimonials";
import Whatinit from "@/components/landing/homeThree/Whatinit";
import HappyUsers from "@/components/landing/homeTwo/HappyUsers";

export default function HomeThree() {
  return (
    <main className="overflow-x-hidden">
      {/* Banner section */}
      <Banner />

      {/* How Its Work section */}
      <HowItsWork />

      {/* What init section */}
      <Whatinit />

      {/* Features section */}
      <Features />

      {/* Happy Users section */}
      <HappyUsers />

      {/* Testimonials section */}
      <Testimonials />

      {/* Call To Action section */}
      <CallToAction />

      {/* Faqs section */}
      <Faqs />
    </main>
  );
}
